import { AppState } from '../rootReducer';
import { SalesState } from './types';

export const salesSelectors = {
  getSalesSummary: (state: AppState): SalesState['summary'] => state.sales.summary,
  getSalesGrossNetStat: (state: AppState): SalesState['salesGrossNetStat'] => state.sales.salesGrossNetStat
};
